import React from "react";
import Marty from "marty";

let ReturnPolicy = React.createClass({
    render() {
        return (
            <section className="eo-sub-view return-policy">
                <h2>Return &amp; refund policy</h2>

                <p>If you are unsatisfied with your purchase of a new eero device (“Product”) that you purchased on eero.com, you have 30 days from the date of purchase to notify eero and request a refund of the purchase price. To qualify for a refund from eero, you must meet all of the conditions of eero’s Return & Refund Policy, found below. If you purchased the Product from an authorized reseller, you must request a refund directly from the reseller. Returns to resellers are subject to the reseller’s return policy, which may differ from eero’s.</p>

                <ol>
                    <li>
                        <h3>To qualify for a refund, all the following conditions must be met:</h3>
                        <ul>
                            <li>A Return Merchandise Authorization (RMA) must be requested from our customer service team within 30 days of the date on which you purchased the Product.</li>
                            <li>To request an RMA, you must contact our customer service team via our website at eero.com or via email addressed to <a
                                href="mailto:returns@eero.com">returns@eero.com</a>.
                            </li>
                            <li>eero must receive the returned Product within 14 days after a RMA number has been issued. An assigned RMA number is valid for 14 days only and will expire on the 15th
                                day after the date of issuance, at which time any returned Product will be refused.
                            </li>
                            <li>Any accessories originally included with the Product you purchased must be included with your return.</li>
                            <li>eero may require that you furnish proof of purchase details to obtain an RMA.</li>
                            <li>Returned Product(s) must be in good physical condition (not physically broken or damaged), in either its original packaging or packaging providing an equal degree of
                                protection. Please ensure that any previous shipping labels or other markings have been removed or covered completely. A valid RMA number must be included along with
                                your returned Product(s).
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h3>Additional terms and conditions:</h3>
                        <ul>
                            <li>To ensure successful delivery, you are required to ship the returned Product(s) using the prepaid return shipping label emailed to you by eero. eero will not be
                                responsible for returned Product(s) sent using an alternate carrier or shipping label. It is your responsibility to retain a copy of the shipping label with the
                                applicable tracking number signed by an agent of the carrier as proof that the possession of the returned product shipment was transferred to the carrier.
                            </li>
                            <li>eero will deduct return shipping costs, gift wrap fees, and taxes paid (e.g., state, customs, VAT) from the amount of your refund.</li>
                            <li>You shall assume all risk of loss or damage to the Product while in transit to eero. If you return a Product to eero (a) without a valid RMA from eero or (b) without
                                all parts included in the original package, eero retains the right to either (1) refuse delivery of such return or (2) deduct from the refund paid to you a restocking
                                fee equal to the higher of (i) fifteen (15) per cent of the original price of the Product or (ii) the retail value of the missing parts.
                            </li>
                            <li>Refunds will be processed and paid within 2 weeks of eero’s receipt of the Product.</li>
                            <li>Refunds will be reimbursed in the original form of purchase.</li>
                        </ul>
                    </li>
                </ol>
            </section>
        );
    },
    getInitialState() {
        return {};
    }
});

export default Marty.createContainer(ReturnPolicy, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/legal/views/return-policy/Handler.js
 **/